import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import Router from 'router';
import configureStores from './redux/store';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './index.css';
import { AuthProvider } from 'router/AuthProvider';
import i18n from 'lang/i18n';
import { I18nextProvider } from 'react-i18next';
import LanguageReadyGate from 'utils/LanguageReadyGate';

const { store } = configureStores();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <LanguageReadyGate>
          <AuthProvider>
            <Router />
          </AuthProvider>
        </LanguageReadyGate>
      </I18nextProvider>
    </Provider>
  </React.StrictMode>
);
